export interface FlowStep {
  number: number;
  label: string;
  active?: boolean;
  completed?: boolean;
  route?: string;
}

type DetailsRoute = '/new-project' | '/existing-project' | null;

export function getProjectTeamSteps(
  detailsRoute: DetailsRoute,
  questionnaireVisited: boolean,
  responseVisited: boolean,
  includeResponse: boolean = true,
): readonly FlowStep[] {
  const steps: FlowStep[] = [
    { number: 1, label: 'Project Team', active: true, completed: false, route: '/project-team' },
    {
      number: 2,
      label: 'Project Details',
      completed: !!detailsRoute,
      route: detailsRoute ?? undefined,
    },
    {
      number: 3,
      label: 'Questionnaire',
      completed: questionnaireVisited,
      route: questionnaireVisited ? '/questionnaire' : undefined,
    },
  ];

  if (includeResponse) {
    steps.push({
      number: 4,
      label: 'Response',
      completed: responseVisited,
      route: responseVisited ? '/response-page' : undefined,
    });
  }

  return steps;
}

export function getNewProjectSteps(
  questionnaireVisited: boolean,
  responseVisited: boolean,
  includeResponse: boolean = true,
): readonly FlowStep[] {
  const steps: FlowStep[] = [
    { number: 1, label: 'Project Team', completed: true, route: '/project-team' },
    { number: 2, label: 'Project Details · New', active: true, route: '/new-project' },
    {
      number: 3,
      label: 'Questionnaire',
      completed: questionnaireVisited,
      route: questionnaireVisited ? '/questionnaire' : undefined,
    },
  ];

  if (includeResponse) {
    steps.push({
      number: 4,
      label: 'Response',
      completed: responseVisited,
      route: responseVisited ? '/response-page' : undefined,
    });
  }

  return steps;
}

export function getExistingProjectSteps(
  questionnaireVisited: boolean,
  responseVisited: boolean,
  includeResponse: boolean = true,
): readonly FlowStep[] {
  const steps: FlowStep[] = [
    { number: 1, label: 'Project Team', completed: true, route: '/project-team' },
    { number: 2, label: 'Project Details · Existing', active: true, route: '/existing-project' },
    {
      number: 3,
      label: 'Questionnaire',
      completed: questionnaireVisited,
      route: questionnaireVisited ? '/questionnaire' : undefined,
    },
  ];

  if (includeResponse) {
    steps.push({
      number: 4,
      label: 'Response',
      completed: responseVisited,
      route: responseVisited ? '/response-page' : undefined,
    });
  }

  return steps;
}

export function getQuestionnaireSteps(
  isNewProject: boolean,
  responseVisited: boolean,
  includeResponse: boolean = true,
): readonly FlowStep[] {
  const steps: FlowStep[] = [
    { number: 1, label: 'Project Team', completed: true, route: '/project-team' },
    {
      number: 2,
      label: 'Project Details',
      completed: true,
      route: isNewProject ? '/new-project' : '/existing-project',
    },
    { number: 3, label: 'Questionnaire', active: true, route: '/questionnaire' },
  ];

  if (includeResponse) {
    steps.push({
      number: 4,
      label: 'Response',
      completed: responseVisited,
      route: responseVisited ? '/response-page' : undefined,
    });
  }

  return steps;
}

export function getResponseSteps(isNewProject: boolean): readonly FlowStep[] {
  return [
    { number: 1, label: 'Project Team', completed: true, route: '/project-team' },
    {
      number: 2,
      label: 'Project Details',
      completed: true,
      route: isNewProject ? '/new-project' : '/existing-project',
    },
    { number: 3, label: 'Questionnaire', completed: true, route: '/questionnaire' },
    { number: 4, label: 'Response', active: true, route: '/response-page' },
  ];
}